module.exports = __webpack_public_path__ + "static/media/wifi-slash.c0eb02c4.svg";